module.exports = "<p>\n  send-mail works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/templates/send-mail.component.html
// module id = 591
// module chunks = 0